import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Slider from 'react-slick';
import CloudinaryImage from 'common/image/CloudinaryImage';
import Card from 'common/card/Card';
import PhotosCardPanelArrow from './PhotosCardPanelArrow';

class PhotosCardPanel extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        images: PropTypes.arrayOf(PropTypes.object)
    };
    static defaultProps = {
        images: []
    };

    constructor(props) {
        super(props);

        this._IMAGE_DIMENSIONS = (props.isMobile) ? 122 : 144;
    }

    _renderImages() {
        return this.props.images.map(image => {
            return (
                <div
                    key={image.id}
                    className="PhotosCardPanel-slide"
                >
                    <CloudinaryImage
                        cloudinaryImageId={image.id}
                        width={this._IMAGE_DIMENSIONS}
                        height={this._IMAGE_DIMENSIONS}
                    />
                </div>
            );
        });
    }

    render() {
        const {
            isMobile,
            images
        } = this.props;
        const noSlide = (!isMobile && images.length < 3);
        const cardPanelClasses = classNames(
            'PhotosCardPanel',
            {'PhotosCardPanel-no-slide': noSlide}
        );
        const sliderClasses = classNames(
            'PhotosCardPanel-slider',
            {scrolling: isMobile}
        );

        return (
            <Card
                className={cardPanelClasses}
                title="Location Photos"
            >
                {(isMobile || noSlide)
                    ? (
                        <div className={sliderClasses}>
                            {this._renderImages()}
                        </div>
                    ) : (
                        <Slider
                            className="PhotosCardPanel-carousel"
                            prevArrow={<PhotosCardPanelArrow direction="left" />}
                            nextArrow={<PhotosCardPanelArrow direction="right" />}
                            slidesToShow={3}
                            slidesToScroll={3}
                            infinite={false}
                        >
                            {this._renderImages()}
                        </Slider>
                    )
                }
            </Card>
        );
    }
}

export default PhotosCardPanel;
